<template>
  <div>
    <!-- <div class="top-sticky">
      <a-menu v-model="selectedKey" mode="horizontal">
        <a-menu-item key="tree" @click="goToView()">
          <a-icon type="apartment" /> Cấu trúc
        </a-menu-item>
        <a-menu-item key="list" @click="goToView('list')">
          <a-icon type="ordered-list" /> Danh sách
        </a-menu-item>
      </a-menu>
    </div> -->
    <TableDepartment />

    <!-- <div v-if="view === 'list'">
      <TableDepartment />
    </div>
    <div v-else>
      <TreeDepartment />
    </div> -->
  </div>
</template>
<script>
import TableDepartment from "./components/tableDepartment";
import TreeDepartment from "./components/treeDepartment";

export default {
  components: {
    TableDepartment,
  },
  computed: {
    view() {
      return this.$route.query.view;
    },
  },
  data() {
    return {
      selectedKey: [],
    };
  },
  methods: {
    goToView(view) {
      this.$router.push({ name: "department", query: { view } });
    },
  },
  mounted() {
    if (this.$route?.query?.view) {
      this.selectedKey = [this.$route.query.view];
    } else {
      this.selectedKey = ["tree"];
    }
  },
};
</script>
<style>
/* .ant-drawer.ant-drawer-open .ant-drawer-mask {
  opacity: 0;
} */
div.top-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
  /* box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1); */
  /* border-bottom: 1px solid #ddd; */
}
</style>
